module.exports = __webpack_public_path__ + "static/media/fish.17582152.png";